import { withPageProps } from '@airship-platform/airship-patterns';
import { Route, Routes } from 'react-router';
import { ProposalTemplatesPage } from '../proposal-templates';
import ManualOptionPage from './ManualOptionPage';
import OptionFormProvider from './optionsForm/OptionFormProvider';

const addPageProps = (comp: React.FC, title: string) =>
  withPageProps(comp, { title });

const manualOptionPage = addPageProps(
  ManualOptionPage,
  'Manual Proposal Options'
);

const ManageOptionPage: React.FC = () => (
  <OptionFormProvider>
    <Routes>
      <Route path="/">
        <Route index Component={manualOptionPage} />
        <Route path="templates/*" Component={ProposalTemplatesPage} />
      </Route>
    </Routes>
  </OptionFormProvider>
);

export default ManageOptionPage;
